<template>
  <div>
    <!-- 조직 등록 및 수정 폼 -->
    <b-card title="조직 등록 및 연합 관리">
      <b-form @submit.prevent="onSubmit">
        <!-- 조직명 입력 -->
        <b-form-group label="조직명" label-for="organizationName-input" description="조직의 이름을 입력하세요.">
          <b-form-input
            id="organizationName-input"
            v-model="organization.organizationName"
            required :readonly="this.id != undefined"
          ></b-form-input>
        </b-form-group>

        <!-- 조직 Prefix 입력 -->
        <b-form-group label="조직 Prefix" label-for="organizationPrefix-input" description="조직 Prefix는 반드시 7자리여야 합니다.(숫자만입력)">
          <b-form-input
            id="organizationPrefix-input"
            required :readonly="this.id != undefined"
            v-model="organization.organizationPrefix"
            maxlength="7"
            @input="validatePrefix"
            :state="isPrefixValid"
          ></b-form-input>
        </b-form-group>

        <!-- Prefix 유형 선택 -->
        <b-form-group label="Prefix 유형" label-for="prefixType-select">
          <b-form-select
            id="prefixType-select"
            required :disabled="this.id != undefined"
            v-model="organization.prefixType"
            :options="barcodeTypeOptions"
          ></b-form-select>
        </b-form-group>
        <!-- 이메일 입력 -->
        <b-form-group label="이메일" label-for="email-input">
          <b-form-input
            type="email"
            id="email-input"
            v-model="cognito.email" :readonly="this.id != undefined"
            required
          ></b-form-input>
        </b-form-group>
    <!-- 초기 비밀번호 입력 및 리셋 버튼 -->
    <b-form-group label="초기 비밀번호" label-for="password-input" description="비밀번호는 8자이상 입력하세요">
      <b-row>
        <b-col cols="9"> <!-- 입력 필드 너비를 9로 설정 -->
          <b-form-input
            id="password-input"
            v-model="cognito.initialPassword"
            minlength="8"
            :required="!this.id"
            :state="passwordState"
          ></b-form-input>
        </b-col>
        <b-col cols="3" class="text-right"> <!-- 버튼 너비를 3으로 설정 -->
          <b-button variant="danger" @click="resetPassword">리셋</b-button>
        </b-col>
      </b-row>
    </b-form-group>


        <!-- 등록 버튼 -->
        <b-button type="submit" variant="primary" v-if="!this.id">조직 등록</b-button>
      </b-form>
    </b-card>

    <!-- 연합 등록 폼 -->
    <b-card title="연합 등록" class="mt-3" v-if="this.id">
      <b-form @submit.prevent="addAlliance">
        <!-- 연합명 입력 -->
        <b-form-group label="연합명" label-for="allianceName-input" description="연합의 이름을 입력하세요.">
          <b-form-input
            id="allianceName-input"
            v-model="newAlliance.allianceName"
            required
          ></b-form-input>
        </b-form-group>

        <!-- 연합 대상 조직 선택 -->
        <b-form-group label="조직 선택" label-for="company-select">
          <b-form-select
            id="company-select"
            required
            v-model="newAlliance.company"
            :options="organizationOptions"
            @change="onCompanyChange"
          ></b-form-select>
        </b-form-group>
        
        <!-- 추가 버튼 -->
        <b-button type="submit" variant="secondary">연합 추가</b-button>
      </b-form>
    </b-card>

    <!-- 연합 목록 테이블 -->
    <b-card title="연합 목록" class="mt-3" v-if="this.id">
      <b-table
        :items="alliances"
        :fields="allianceFields"
        striped
        bordered
        hover
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="deleteAlliance(data.item)">삭제</b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import hal from 'hateoas-hal-link-resolver';

export default {
  props: ['id'],
  data() {
    return {
      organization: {
        organizationName: '',
        organizationPrefix: '',
        prefixType: null,
        alliances: []
      },
      isPrefixValid: true, // Prefix 유효성 상태
      alliances: [],
      cognito: {
        initialPassword: '',
        email: null
      },
      barcodeTypeOptions: [
        { value: null, text: '선택해 주세요' },
        { value: 'GS1', text: 'GS1' },
        { value: 'KFT', text: 'KFT' }
      ],
      organizationOptions: [],
      newAlliance: {
        allianceName: null,
        company: null
      },
      allianceFields: [
        { key: 'allianceName', label: '이름' },
        { key: 'company.organizationName', label: '조직' },
        { key: 'actions', label: '조작' }
      ]
    };
  },
  methods: {
    async fetchOrganizationData(id) {
      try {
        const response = await this.$http.get(`api/organization/${id}`);
        
        this.organization = response.data;
        console.log(response.data, this.organization)
        const alliance = await this.$http.get(hal(this.organization, 'alliances'));       
        this.organization.alliances = alliance.data._embedded.alliance;
      } catch (error) {
        console.error('Error fetching organization:', error);
      }
    },
    async fetchAlliancesData() {
      try {
        if(!this.id)return;
        const alliance = await this.$http.get(`${hal(this.organization, 'alliances')}?projection=withCompany`);       
        console.log('fetchAlliancesData=> ', alliance)
        this.alliances = alliance.data._embedded.alliance;
      } catch (error) {
        console.error('Error fetching organization:', error);
      }
    },
    validatePrefix() {
      // Prefix가 7자리인지 확인
      this.isPrefixValid = this.organization.organizationPrefix.length === 7;
    },
    async onSubmit() {
      // console.log('등록된 조직 정보:', this.organization);
      try {
        if (!this.id) {
          const findNameRes = await this.$http.get('api/organization/search/existsByOrganizationName?organizationName=' + encodeURIComponent(this.organization.organizationName));
          if (findNameRes.data) {
            alert('이미 등록된 조직명입니다.');
            return;
          }
          const findPrefixRes = await this.$http.get('api/organization/search/existsByOrganizationPrefix?organizationPrefix=' + this.organization.organizationPrefix);
          if (findPrefixRes.data) {
            alert('이미 등록된 조직 Prefix 입니다.');
            return;
          }
        }
        const res = await this.$http.post('api/organization', Object.assign(this.organization, this.cognito));
        console.log('save org=>', res.data.id)

        alert('정상적으로 등록되었습니다.')
        this.$router.push({ name: '조직수정', params: { id: res.data.id } });
      }catch(e){
        alert(e);
      }

      // 서버로 데이터 전송 혹은 저장 로직
      // 여기에 조직 정보를 서버에 저장하는 로직 추가 필요
    },
    async addAlliance() {
      // 신규 조직인지 확인
      if (!this.id) {
        alert('먼저 조직을 등록해 주세요.');
        return;
      }
      this.newAlliance.organization = hal(this.organization, 'self')
      await this.$http.post('api/alliance', this.newAlliance )
      this.$bvToast.toast('추가되었습니다.', {
        title: `200 OK`,
        variant: 'primary',
        solid: true
      })
      // console.log(this.newAlliance )
      await this.fetchAlliancesData();
      this.resetNewAllianceForm();
    },
    deleteAlliance(alliance) {
      this.organization.alliances = this.organization.alliances.filter(a => a !== alliance);
    },
    resetNewAllianceForm() {
      this.newAlliance = {
        allianceName: '',
        company: null
      };
    },
    async resetPassword() {
      if(this.cognito.initialPassword && this.passwordState) {
        // console.log(this.passwordState, this.organization.organizationName, this.cognito.initialPassword)

        if(confirm('로그인 조직의 비밀번호를 초기화 하시겠습니까?')) {
          await this.onPasswordReset(this.organization.organizationName, this.cognito.initialPassword);
        }
        
      }
      if(!this.id) {
        this.cognito.initialPassword = ''
      }
    },

    async onPasswordReset(userName, password) {

    const url = `api/user/resetPassword?username=${userName}&newPassword=${password}`;
      this.$http.get(url)
        .then(response => {
          alert(`성공 ${userName} password has been successfully reset.`);
        }).catch(err => {
          alert(err);
        })
    },
    async createOrgCombo(){
      const organization = await this.$http.get('api/organization');
      const editId = this.id;
      const orgs = organization.data._embedded.organization.filter(item => item.id != editId).map(item => ({
        text: item.organizationName,
        value: item._links.self.href
      }));
      this.organizationOptions = [{ value: null, text: '선택하세요' }].concat(orgs);
    },
    onCompanyChange(selectedValue) {
      const selVal = this.getLastSegmentFromUrl(selectedValue);
      const hasAlli = this.alliances.filter(alli => alli.company.id == selVal).length > 0;

      console.log('hasAlli', hasAlli)

      if(hasAlli) {
        alert('이미 추가된 연합입니다.');
        this.newAlliance.company = null;
        return;
      }
    },
    getLastSegmentFromUrl(url) {
      // URL을 '/'로 분리하여 배열로 만들고, 마지막 요소를 반환
      const segments = url.split('/');
      return segments.pop() || segments.pop(); // '//'가 있는 경우 빈 문자열이 될 수 있으므로 안전하게 처리
    },
  },
  async created() {
    if (this.id) {
      await this.fetchOrganizationData(this.id);
      const cognito = new this.$cognito();
      const form = this.cognito;
      cognito.getUserEmail(this.organization.organizationName, function(err, data){
        if(data) {
          const email_attr = data.UserAttributes.find(attr => attr.Name == 'email');
          form.email = email_attr['Value'];
        }
      })
    }
    await this.fetchAlliancesData();
    await this.createOrgCombo();
  },
  computed: {
    passwordState() {
      if(this.id) {
        return this.cognito.initialPassword === '' || this.cognito.initialPassword.length >= 8;
      }else {
        return this.cognito.initialPassword.length >= 8;
      }
      
    }
  },
};
</script>

<style scoped>
/* 필요에 따라 스타일링 추가 */
</style>
